import { SubMenuIcon } from '@model-framework/menu';
import { SubMenuBox } from '@model-framework/menu/MenuBox';
import { StickyZoneShape } from '../../../domain';
import { faCircle, faSquare } from '@fortawesome/free-regular-svg-icons';
import type { IconDefinition } from '@fortawesome/free-regular-svg-icons';
type Props = {
  zoneShape: StickyZoneShape;
  menuSize: number;
  isSelected: boolean;
  onClick(): void;
};

const zoneShapeToIcon: { [key in StickyZoneShape]: IconDefinition } = {
  [StickyZoneShape.Circle]: faCircle,
  [StickyZoneShape.Rectangle]: faSquare,
};

export const ZoneShapeSubMenu: React.FC<Props> = ({ zoneShape, menuSize, isSelected, onClick }: Props) => {
  return (
    <>
      <SubMenuBox menuSize={menuSize} isSelected={isSelected} onClick={onClick} />
      <SubMenuIcon icon={zoneShapeToIcon[zoneShape]} menuSize={menuSize} isSelected={isSelected} />
    </>
  );
};
